import gql from 'graphql-tag'

import { MapsBoundsFieldsFragment } from './bounds'

export { MapsGeocodeResultFields } from './__generated__/MapsGeocodeResultFields'

export const MapsGeocodeResultFieldsFragment = gql`
  fragment MapsGeocodeResultFields on MapsGeocodeResult {
    latitude
    longitude
    viewport {
      ...MapsBoundsFields
    }
    city
    state
    country
  }

  ${MapsBoundsFieldsFragment}
`
